import React from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './Hero.css';

const Hero = () => {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);

  return (
    <section className="hero">
        <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-main-title">{t('heroTitle1')}</span>
            <span className="hero-main-title">{t('heroTitle2')}<strong>{t('heroTitle2Bold')}</strong>{t('heroTitle2Suffix')}</span>
          </h1>
          <p className="hero-description">
            {t('heroDesc1')}<span className="accent-font">{t('heroDesc1Partner')}</span>{t('heroDesc1Rest')}<strong className="highlight-green">{t('heroDesc1Highlight')}</strong>{t('heroDesc1End')}
          </p>
          <p className="hero-description">
            {t('heroDesc2')}<br />
            {t('heroDesc2Line2')}
          </p>

        </div>
      </div>
    </section>
  );
};

export default Hero;

